import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { QuillModule } from 'ngx-quill';
import { ToastrModule } from 'ngx-toastr';
import { ProfileService } from 'src/app/shared/service/profile.service';
import { guards } from '../core/guards';
import { interceptors } from '../core/interceptors';
import { services } from '../core/services';
import { components, entryComponents } from '../modules/home/components';
import { NumbersOnlyInputDirective, NumericDirective } from '../shared/directive/only-number.directive';
import { VideoUrlValidator } from '../shared/directive/url-video.directive';
import { materialForm, materialTable, sharedMaterials } from '../shared/material';
import "../shared/prototypes/array.prototype";
import { SharedModule } from '../shared/shared.module';
import '../shared/prototypes/date.prototype';
import '../shared/prototypes/form-control.prototype';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LanguageButtonComponent } from './language-button/language-button.component';
import { LayoutComponent } from './layout/layout.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
(function registerChartDataLabelsForChartJs() {
	Chart.plugins.register(ChartDataLabels);
})();

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    LanguageButtonComponent,
    components,
    NumericDirective,
    NumbersOnlyInputDirective,
    VideoUrlValidator,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: false
    }),
    QuillModule.forRoot(),
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    sharedMaterials,
    materialForm,
    materialTable
  ],
  providers: [...services, ...guards, ...interceptors,
  { provide: APP_INITIALIZER, useFactory: userContextFactory, deps: [ProfileService], multi: true}
],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  entryComponents: [entryComponents],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function userContextFactory(provider: ProfileService) {
  return () => provider.initUserContext();
}
